import React from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@mui/material";
import moment from "moment";
import PanoramaFishEyeTwoToneIcon from "@mui/icons-material/PanoramaFishEyeTwoTone";
import {amber, indigo} from "@mui/material/colors";

const MonitoraggiQuarantenaTable = ({monitoraggi}) => {
	return (
		<React.Fragment>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography align={"left"}
							            style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Data</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Tosse</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Mal di gola</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Dispnea</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Cefalea</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Alt. gusto</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Alt. olfatto</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Brividi</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Mialgia</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Inappetenza</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Vomito</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Diarrea</b>
							</Typography>
						</TableCell>
						<TableCell style={{verticalAlign: "bottom"}}>
							<Typography style={{textOrientation: "mixed", writingMode: "vertical-rl", transform: "rotate(180deg)"}}>
								<b>Raffreddore</b>
							</Typography>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{
						monitoraggi.sort(function (a, b) {
								return new Date(b.dataInserimento) - new Date(a.dataInserimento);
							})
							.map((monitoraggio) => {
								return (
									<TableRow key={monitoraggio.id} hover>
										<TableCell>
											<Typography
												variant={"body2"}>{moment(monitoraggio.dataInserimento).format("DD/MM/YY")}</Typography>
											<Typography variant={"body2"} style={{fontSize: 14}}
											            color={"textSecondary"}>{moment(monitoraggio.dataInserimento).format("HH:mm")}</Typography>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.tosse ? {color: indigo["A700"]} : monitoraggio?.tosse === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.malDiGola ? {color: indigo["A700"]} : monitoraggio?.malDiGola === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.dispnea ? {color: indigo["A700"]} : monitoraggio?.dispnea === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.cefalea ? {color: indigo["A700"]} : monitoraggio?.cefalea === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.alterazioneGusto ? {color: indigo["A700"]} : monitoraggio?.alterazioneGusto === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.alterazioneOlfatto ? {color: indigo["A700"]} : monitoraggio?.alterazioneOlfatto === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.brividi ? {color: indigo["A700"]} : monitoraggio?.brividi === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.mialgia ? {color: indigo["A700"]} : monitoraggio?.mialgia === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.inappetenza ? {color: indigo["A700"]} : monitoraggio?.inappetenza === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.vomito ? {color: indigo["A700"]} : monitoraggio?.vomito === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.diarrea ? {color: indigo["A700"]} : monitoraggio?.diarrea === null ? {color: amber[500]} : {}}/>
										</TableCell>
										<TableCell>
											<PanoramaFishEyeTwoToneIcon
												style={monitoraggio?.raffreddore ? {color: indigo["A700"]} : monitoraggio?.raffreddore === null ? {color: amber[500]} : {}}/>
										</TableCell>
									</TableRow>
								)
							})
					}
				</TableBody>
			</Table>
		</React.Fragment>
	);
};

export default React.memo(MonitoraggiQuarantenaTable);
